/**
 * Supafit App Landing — Pricing Configurator
 * Reads band option data from data-* attributes rendered by Liquid.
 */
(function () {
  'use strict';

  const root = document.querySelector('[data-supafit-pricing]');
  if (!root) return;

  // ── State ──────────────────────────────────────────────────
  let currentSetKey = null;
  let hasBar = false;
  let configOpen = false;
  let selectedBandEl = null;

  const appPrice = parseInt(root.dataset.appPrice || '0', 10);

  // ── Elements ───────────────────────────────────────────────
  const toggleBtn      = root.querySelector('[data-band-toggle]');
  const configPanel    = root.querySelector('[data-band-config]');
  const bottomPanel    = root.querySelector('[data-pricing-bottom]');
  const totalAmount    = root.querySelector('[data-total-amount]');
  const totalBreakdown = root.querySelector('[data-total-breakdown]');
  const bandOptions    = root.querySelectorAll('[data-band-option]');
  const barSelector    = root.querySelector('[data-bar-selector]');
  const barOptions     = root.querySelectorAll('[data-bar-option]');
  const addToCartBtn   = root.querySelector('[data-add-to-cart]');

  if (!toggleBtn || !configPanel || !bottomPanel) return;

  // Capture button label before any state changes
  if (addToCartBtn) {
    addToCartBtn.dataset.label = addToCartBtn.textContent.trim();
  }

  // Pre-select first band option
  if (bandOptions.length) {
    selectedBandEl = bandOptions[0];
    selectedBandEl.classList.add('selected');
    currentSetKey = selectedBandEl.dataset.setKey;
  }

  // Pre-select "No Bar"
  if (barOptions.length) {
    barOptions[0].classList.add('selected');
    hasBar = barOptions[0].dataset.hasBar === 'true';
  }

  // Populate total immediately so it's ready when the panel opens
  updateTotal();

  // ── Toggle configurator ────────────────────────────────────
  toggleBtn.addEventListener('click', function () {
    configOpen = !configOpen;
    configPanel.classList.toggle('open', configOpen);
    bottomPanel.classList.toggle('open', configOpen);
    toggleBtn.classList.toggle('active', configOpen);
    toggleBtn.textContent = configOpen
      ? (toggleBtn.dataset.labelClose || 'Choose Your Bands Set ↑')
      : (toggleBtn.dataset.labelOpen  || 'Choose Your Bands Set ↓');
  });

  // ── Band selection ─────────────────────────────────────────
  bandOptions.forEach(function (opt) {
    opt.addEventListener('click', function () {
      bandOptions.forEach(function (o) { o.classList.remove('selected'); });
      opt.classList.add('selected');
      selectedBandEl = opt;
      currentSetKey = opt.dataset.setKey;
      updateTotal();
    });
  });

  // ── Bar selection ──────────────────────────────────────────
  barOptions.forEach(function (opt) {
    opt.addEventListener('click', function () {
      barOptions.forEach(function (o) { o.classList.remove('selected'); });
      opt.classList.add('selected');
      hasBar = opt.dataset.hasBar === 'true';
      updateTotal();
    });
  });

  // ── Total calculation ──────────────────────────────────────
  function updateTotal() {
    if (!selectedBandEl) return;

    const bandPrice = hasBar
      ? (parseInt(selectedBandEl.dataset.priceBar,   10) || 0)
      : (parseInt(selectedBandEl.dataset.priceNobar, 10) || 0);

    const total = bandPrice + appPrice;

    if (totalAmount) totalAmount.textContent = '$' + total;
    if (totalBreakdown) {
      totalBreakdown.textContent = appPrice > 0
        ? '$' + bandPrice + ' bands' + (hasBar ? ' with bar' : '') + ' + $' + appPrice + ' app'
        : '';
    }

    bandOptions.forEach(function (opt) {
      const priceEl = opt.querySelector('[data-band-display-price]');
      if (!priceEl) return;
      const price = hasBar
        ? (parseInt(opt.dataset.priceBar,   10) || 0)
        : (parseInt(opt.dataset.priceNobar, 10) || 0);
      priceEl.textContent = '$' + price;
    });
  }

  // ── Add to cart ────────────────────────────────────────────
  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function () {
      if (!selectedBandEl) return;

      const variantId = hasBar
        ? selectedBandEl.dataset.variantBar
        : selectedBandEl.dataset.variantNobar;

      if (!variantId) {
        showCartError('This configuration is unavailable. Please try another selection.');
        return;
      }

      setLoading(true);
      clearCartError();

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
      })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (data) {
            throw new Error(data.description || 'Could not add to cart.');
          });
        }
        return res.json();
      })
      .then(function (response) {
        window.HPGOpenAIAds?.trackCartAddResponse(response);
        window.location.href = '/cart';
      })
      .catch(function (err) {
        setLoading(false);
        showCartError(err.message || 'Something went wrong. Please try again.');
      });
    });
  }

  function setLoading(loading) {
    if (!addToCartBtn) return;
    addToCartBtn.disabled = loading;
    addToCartBtn.textContent = loading ? 'Adding...' : addToCartBtn.dataset.label;
    addToCartBtn.classList.toggle('sf-btn-pricing--loading', loading);
  }

  function showCartError(msg) {
    let el = root.querySelector('[data-cart-error]');
    if (!el) {
      el = document.createElement('p');
      el.setAttribute('data-cart-error', '');
      el.className = 'sf-cart-error';
      bottomPanel.appendChild(el);
    }
    el.textContent = msg;
    el.style.display = 'block';
  }

  function clearCartError() {
    const el = root.querySelector('[data-cart-error]');
    if (el) el.style.display = 'none';
  }
})();
